module.exports = __webpack_public_path__ + "static/media/selfie-document-instructions.79ad010a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/common/photo-identity/selfie-document-instructions.png
 ** module id = 2053
 ** module chunks = 0
 **/